import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from "react-helmet"

import Layout from '../components/Layout'
import JumboTron from '../components/JumboTron'
import Blocks from '../lib/blocks';
import MetaTags from '../components/MetaTags';
import H1 from '../components/Headers/H1';
import ContentWrapper from '../components/ContentWrapper';
import Block from '../components/Block';
import Column from '../components/Column';
import markdown from '../lib/remark';
import ImageZoom from "react-medium-image-zoom";
import H2 from '../components/Headers/H2';
import News from '../components/blocks/News';
import moment from 'moment'

export default function NewsBlock({ data }) {
    const page = data.datoCmsNews

    const metaTags = MetaTags(page.seoMetaTags);

    const visuals = page.visuals.map(element => (
        <ImageZoom
            key={element.url}
            image={{
                src: `${element.url}?w=600&q=85`,
                alt: element.alt,
                className: "visual  mb-4  max-w-full"
            }}
            zoomImage={{
                src: `${element.url}?w=1200&auto=format`,
                alt: element.alt,
                className: "visual"
            }}
            style={{ zIndex: 667 }}
        />
    ));


    return (
        <Layout>
            <Helmet title={page.pageTitle}>
               {metaTags}
            </Helmet>

            <ContentWrapper>
                <Block responsiveStackedReverse>
                    <Column>
                        <H2>News</H2>
                        <News active={parseInt(page.id)} />
                    </Column>

                    <Column>
                        <H1>{page.title}</H1>
                        <span className="cms-content text-black mb-3 block">
                            {moment(page.publishDate).format('MMMM Do, YYYY')}
                        </span>

                        <div className="cms-content" dangerouslySetInnerHTML={markdown(page.body)} />

                        {visuals}
                    </Column>
                </Block>
            </ContentWrapper>
        </Layout>
    )
}

export const query = graphql`
    query($slug: String!) {
            datoCmsNews(slug: {eq: $slug}) {
                id
                title
                body
                publishDate
                seoMetaTags {
                    tags
                }
                visuals {
                    originalId
                    url
                    alt
                    title
                }
            }
        }
`
